import React, { useState } from 'react'
import { Drawer, Dropdown, Menu, Tabs } from 'antd'
import { Route, Switch, useHistory, Link, useParams } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { useToggle, stringifyDate, usePet, normalize, summarizeProcurementInvoice, summarizeProcurementInvoiceItem } from '../../modules'

import InvoiceItem from './invoiceItem'
import Confirm from '../reusable/confirm'

const { TabPane } = Tabs

const Invoice = ({ path, onClose }) => {
    const [chosen, setChosen] = useState([])
    const [selected, setSelected] = useState(null)
    const [index, setIndex] = useState(null)
    const [can, setCan] = useState(null)
    const [params, setParams] = useState({})

    const history = useHistory()
    const { id } = useParams()

    const [visible, toggleVisible] = useToggle(true)
    const [select, toggleSelect] = useToggle()
    const [editModal, toggleEditModal] = useToggle()

    const [{ loading, error, data: invoice }, refetch] = usePet('invoice', { id }, { notify: true })

    const [{ loading: editLoading }, editInvoiceItem] = usePet('editInvoiceItem', {
        parent: id,
        index,
        ...params
    }, { notify: true, callback: refetch, manual: true, load: { msg: 'Saving changes...' } })

    const [{ loading: newLoading }, addItemToInvoice] = usePet('addItemToInvoice', {
        parent: id,
        ...params
    }, { notify: true, callback: refetch, manual: true, load: { msg: 'Saving changes...' } })

    const [{ loading: comLoading }, commitInvoice] = usePet('commitInvoice', { id }, { notify: true, callback: () => {
        refetch()
        onClose()
    }, manual: true, load: { msg: 'Saving changes...' } })
    
    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const selectItems = (val, i) => {
        setSelected(val)
        setIndex(i)
        toggleEditModal()
    }

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }

    const [{ loading: delLoading }, deleteInvoice] = usePet('deleteInvoice', { id }, { notify: true, callback: () => {
        onClose()
        setTimeout(close, 200)
    }, manual: true, load: { msg: 'Saving changes...' } })

    const summary = summarizeProcurementInvoice(invoice?.items, invoice?.amountPaid, invoice?.amountCredited)

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width="60%">
            <p className="font-extrabold text-3xl mb-0">Invoice #{ invoice?.code }</p>
            <div className="flex justify-between items-center">
                <span>
                    <p className="text-gray-500 text-xs italic mb-0">Received from { invoice?.supplier?.name } on { stringifyDate(invoice?.date) } by { invoice?.receivedBy }</p>
                    <div className="text-yellow-500 text-xs italic mb-0">{ invoice?.status }</div>
                </span>
                {
                    !invoice?.committed &&
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={ () => Confirm({
                                    title: 'Commit Invoice?',
                                    message: 'Please confirm before performing this action',
                                    okText: 'Commit Invoice',
                                    onOk: commitInvoice  
                                }) }>Commit Invoice</Menu.Item>
                                <Link to={`${path}/invoices/${id}/new`}>
                                    <Menu.Item>Add Item</Menu.Item>
                                </Link>
                                <Menu.Item onClick={ () => Confirm({
                                    title: 'Delete Invoice?',
                                    message: 'This will delete any record of this invoice from the system',
                                    okText: 'Delete Invoice',
                                    onOk: deleteInvoice  
                                }) }>Delete Invoice</Menu.Item>
                                <Menu.Item>Attach Image</Menu.Item>
                                <Menu.Item>Additional Details</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn m-0 hisani-btn-green-light text-white">
                            <span className="hidden xs:block mr-2">Actions</span>
                            <AiOutlineDown />
                        </button>
                    </Dropdown>
                }
            </div>
            <Tabs className="mt-0">
                <TabPane key="0" tab="Received Items">
                        <table className="table-auto w-full">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">No</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Item</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Quantity</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Price</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Disc</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Tax</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Total</div>
                                    </th>
                                    {
                                        !invoice?.committed &&
                                        <th className="p-2"/>
                                    }
                                </tr>
                            </thead>
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    invoice?.items?.map((item, key) => {
                                        const itemSummary = summarizeProcurementInvoiceItem(item)
                                        return <tr>
                                            <td className="p-2">
                                                <div className="text-center">
                                                    {
                                                        select ?
                                                            <input
                                                                onChange={() => choose(item._id)}
                                                                checked={chosen.includes(item._id)}
                                                                type="checkbox"
                                                                className="form-checkbox cursor-pointer h-5 w-5" />
                                                            : `${key + 1}.`
                                                    }
                                                </div>
                                            </td>
                                            <td className="p-2">
                                                <div className="text-left">{item?.name}</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">{  Math.abs(item.bulkCount) } X { Math.abs(item.containing) } ({ Math.abs(item.bulkCount * item.containing) })</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="text-left">Ksh. { item.bp || item.price }</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">Ksh. { normalize(item?.discount) }</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">{item?.vat}%</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">Ksh. { normalize(itemSummary.total) }</div>
                                            </td>
                                            {
                                                !invoice?.committed &&
                                                <td className="p-2">
                                                    <Link to={ `${path}/invoices/${id}/${key}`}>
                                                        <button onClick={ () => selectItems({
                                                            ...item,
                                                            label: item?.item?.name,
                                                            value: item?.item?._id,
                                                            bulk: item.bulkCount,
                                                            singles: item.singles,
                                                            contains: item.containing,
                                                            batch: item.batchNo,
                                                            issuedIn: item?.item?.issuedIn,
                                                            receivedIn: item?.item?.receivedIn
                                                        }, key) } className="btn hisani-btn-green-light text-white">
                                                            <span className="hidden xs:block mr-2">Edit</span>
                                                        </button>
                                                    </Link>
                                                </td>
                                            }
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table><div className="flex flex-col items-end pr-3 py-3">
                            <p className="font-semibold text-lg underline mb-2">Overview</p>
                            <p className="mb-1">Before Discount: Ksh. {normalize(summary.beforeDiscount)}</p>
                            <p className="mb-1">Discount: Ksh. {normalize(summary.discount)}</p>
                            <p className="mb-1">Before VAT: Ksh. {normalize(summary.beforeTax)}</p>
                            <p className="mb-1">VAT: Ksh. {normalize(summary.vat)}</p>
                            <p className="mb-1">Total: Ksh. {normalize(summary.total)}</p>
                        </div>
                </TabPane>
                <TabPane key="1" tab="Additional Details">

                </TabPane>
            </Tabs>
            <Switch>
                <Route path={ `${path}/invoices/:id/new` }>
                    <InvoiceItem onSave={ val => {
                        Confirm({
                            title: 'Add Item to Invoice?',
                            message: 'This will add the selected item to this invoice',
                            okText: 'Add Item',
                            onOk: () => {
                                setParams({
                                    ...val,
                                    account: val?.account?.value
                                })
                                addItemToInvoice()
                            }  
                        })
                    }} />
                </Route>
                <Route path={ `${path}/invoices/:id/:index` }>
                    <InvoiceItem record={ selected } onSave={ val => {
                        Confirm({
                            title: 'Edit Selected Item?',
                            message: 'This will edit the selected item',
                            okText: 'Edit Item',
                            onOk: () => {
                                setParams({
                                    ...val,
                                    account: val?.account?.value
                                })
                                editInvoiceItem()
                            }  
                        })
                    } } />
                </Route>
            </Switch>
        </Drawer>
    )
}

export default Invoice
